// extracted by mini-css-extract-plugin
module.exports = {"category":"style_category__2I6vi","title":"style_title__2WVR0","contents":"style_contents__1KZMN","subTitle":"style_subTitle__3CqOU","subDescription":"style_subDescription__1iXd2"};